import styled from "@emotion/styled";
import { TableCell, TableContainer, TableHead } from "@mui/material";

import { rgba, shade } from "@skilitics/designer-theme";

export const Cell = styled(TableCell)``;

export const FixedCell = styled(Cell)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const StyledTableHead = styled(TableHead)`
  ${Cell} {
    font-size: ${({ theme }) => theme.fontSizeSmall};
  }

  ${FixedCell} {
    font-size: ${({ theme }) => theme.fontSizeSmall};
  }
`;

export const LinkCell = styled(Cell)`
  padding: 0;
  a {
    height: 100%;
    padding: 8px;
    display: block;
  }
`;

export const StyledTableContainer = styled(TableContainer)`
  background: ${({ theme }) => theme.surface};
  overflow-y: auto;
  max-height: 100%;
  flex: 1 1 auto;
`;

export const CardsTableContainer = styled(TableContainer)`
  padding: 15px 0 25px 0;
  overflow-y: auto;
  max-height: 100%;
  max-width: 100%;
  flex: 1 1 auto;
  > table {
    border-collapse: separate;
    border-spacing: 0 10px;
    max-width: 100%;
    table-layout: fixed;
    th {
      background: transparent;
      padding: 6px 8px;
    }
    tbody tr {
      box-shadow: 0 2px 4px -2px ${({ theme }) => rgba(theme.generalTextIcon, 0.15)};
      border-radius: 10px;
      transition: all 0.2s ease-in-out;
      th {
        padding: 0;
        background: ${({ theme }) => theme.surface};
      }
    }
    td {
      border: 0;
      background: ${({ theme }) => theme.surface};
      padding: 6px 8px;
      transition: all 0.2s ease-in-out;
      &:first-of-type {
        border-radius: 10px 0 0 10px;
      }
      &:last-of-type {
        border-radius: 0 10px 10px 0;
      }
    }
    // Hover state for top-level table rows only.
    > tbody > tr:hover {
      box-shadow: 0 2px 4px -2px ${({ theme }) => rgba(theme.generalTextIcon, 0.4)};
      td {
        background: ${({ theme }) => shade(theme.surface, 0.05)};
      }
    }
  }
`;
